import React from 'react';
import { EventCategoryPage } from '../../components/Events/EventCategoryPage';
import { EVENT_CATEGORIES } from '../../data/eventCategoryData';
const AuthorPanels = () => <EventCategoryPage config={EVENT_CATEGORIES['author-panels']} data-id="element-9841" data-mp="2ka60ojgph8ho" />;
export default AuthorPanels;